import { atom } from 'nanostores'

const params = new URLSearchParams(window.location.search)

export const $debugAfterPaymentError = atom(
  params.has('debug_after_payment_error'),
)
